module.exports = __webpack_public_path__ + "static/img/031树洞日记.b6bc864.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/031树洞日记.jpg
// module id = BlFl
// module chunks = 0